export function keyedByPosition<Row extends object>(
  rows: readonly Row[] | undefined
): (Row & { key: number })[] | undefined {
  return rows?.map((row, position) => ({ ...row, key: position }));
}
